import { render } from "./cartPageSummary.vue?vue&type=template&id=a8b2488c&scoped=true&ts=true"
import script from "./cartPageSummary.vue?vue&type=script&lang=ts"
export * from "./cartPageSummary.vue?vue&type=script&lang=ts"

import "./cartPageSummary.vue?vue&type=style&index=0&id=a8b2488c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b2488c"]])

export default __exports__